import React, {useState, useEffect, useRef } from "react";
import { ConnectPayments, ConnectComponentsProvider } from "@stripe/react-connect-js";
import { useTheme } from '@mui/material/styles';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { CloudFunctions } from "../../FirebaseAuth/firebase";

const Payments = ({accountId}) => {
    const mountedRef = useRef(true);
    const theme = useTheme();
    const [stripeConnectInstance] = useState(() => {
        const fetchSessionSecret = async () => {
            const response = await CloudFunctions.httpsCallable('fetchSessionSecret')({account_id: accountId, type: 'payments'});
            const {error} = response.data;
            if(error!==undefined){
                // Handle errors on the client side here
                console.error('An error occurred: ', error);
                return undefined;
            } else {
                const {client_secret: clientSecret} = response.data;
                return clientSecret;
            }
        }
    
        return loadConnectAndInitialize({
          // This is your test publishable API key.
          publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
          fetchClientSecret: fetchSessionSecret,
          appearance: {
            overlays: "dialog",
            variables: {
                colorText: theme.palette.grey[800],
                colorSecondaryText: theme.palette.text.secondary,
                colorBorder: theme.palette.divider,
                colorBackground: theme.palette.background.paper,
                actionPrimaryColorText: theme.palette.grey[800],
                actionSecondaryColorText: theme.palette.text.secondary,
                buttonPrimaryColorBackground: theme.palette.background.default,
                buttonSecondaryColorBackground: theme.palette.background.paper,
                offsetBackgroundColor: theme.palette.background.paper,
                formBackgroundColor: theme.palette.background.paper,
                spacingUnit: "8px",
                fontSizeBase: "16px",
                headingXlTextTransform: "none"
                },
            }
        })
    });

    const onLoadError = (loadError) => {
        const componentName = loadError.elementTagName
        const error = loadError.error
        console.log(componentName + " failed to load")
        console.log(`${error.type}: ${error.message}`);
    };

    useEffect(() => {
        return () => { 
            mountedRef.current = false
        }
    },[]);

    return (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectPayments 
                onLoadError={onLoadError}
                // defaultFilters={{
                //   status: ['partially_refunded', 'refund_pending', 'refunded'],
                // }}
            />
        </ConnectComponentsProvider>
    )
}

export default Payments;